<ng-container *ngIf="model && model.view">
  <div
    [id]="'file-item-' + resultsIndex"
    #element
    class="file-item"
    [class.blur]="confirmOptions"
    [class.clickable]="model.view.title.onClick"
    tabindex="-1"
    [dragAndDrop]="dragData"
  >
    <link-indicator
      class="link-indicator"
      *ngIf="model.linkIndicator"
      [name]="model.link?.name"
      [color]="model.link?.color"
      [isRestricted]="isRestricted"
    ></link-indicator>
    <div class="file-type-container">
      <u-icon *ngIf="resourceIconModel" class="file-type-icon no-drag" [model]="resourceIconModel"></u-icon>
    </div>

    <div class="main" #main>
      <div
        class="title-container result-line"
        *ngIf="model.view"
        [class.with-subtitle]="model.view.subtitle"
        [class.with-badge]="model.view.badge"
      >
        <result-title
          [model]="model.view.title"
          [highlights]="model.highlights"
          [showSingleLineView]="!model.view.subtitle"
          (contextmenu)="model.view.title.onRightClick ? null : onRightClick($event, 'title')"
          (auxclick)="model.view.title.onRightClick ? null : onAuxClick($event, 'title')"
          (invoke)="
            onInvoke({
              command: $event.command,
              context: makeContext({ appId: model.resource.appId, openWith: model.openWith }, $event.context),
              trigger: $event.trigger,
              source: $event.source,
              immediate: $event.immediate,
            })
          "
          [selected]="selected"
          [dragMetadata]="dragMetadata"
          click-invoker
          #title
        >
        </result-title>
        <result-subtitle
          *ngIf="model.view.subtitle"
          [model]="model.view.subtitle"
          [highlights]="model.highlights"
          (contextmenu)="model.view.subtitle.onRightClick ? null : onRightClick($event, 'subtitle')"
          (auxclick)="model.view.subtitle.onRightClick ? null : onAuxClick($event, 'subtitle')"
          (invoke)="onInvoke($event)"
          click-invoker
          #subtitle
        >
        </result-subtitle>
        <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
          <div class="favorite" click-invoker *ngIf="model?.isFavorite">
            <u-icon class="icon" [model]="{ type: 'font', value: 'icon-star-solid' }"></u-icon>
          </div>
        </ng-container>
      </div>

      <div class="bullets-container result-line" tabindex="-1" *ngIf="!displayOneLine && model.view?.bullets?.length > 0">
        <div class="app-icon-container">
          <u-icon (error)="onIconError($event)" class="app-icon-logo" [model]="appIconModel" *ngIf="appIconModel"></u-icon>
        </div>
        <result-bullet
          data-cy="result-bullet-container"
          tabindex="-1"
          *ngFor="let bullet of model.view.bullets"
          [model]="bullet"
          click-invoker
          (invoke)="onInvoke({ command: $event, trigger: 'mouse_click' })"
        >
        </result-bullet>
      </div>
    </div>

    <div class="buttons-container">
      <restricted-message class="restricted-message" [full]="previewState !== 'sideL'" *ngIf="isRestricted"></restricted-message>
      <square-button
        [active]="contextMenuHelper?.source === 'actions'"
        click-invoker
        (click)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        (auxclick)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        (contextmenu)="$event.stopPropagation(); openContextMenu($event, 'actions')"
        #actions
        >•••</square-button
      >
    </div>

    <div class="blocker" *ngIf="model.deleted"></div>
    <div class="confirm" *ngIf="confirmOptions" (click)="onConfirm(null, $event)">
      <span class="message" *ngIf="confirmOptions.message !== null">{{ confirmOptions.message || 'Are you sure?' }}</span>
      <button class="cancel-btn" (click)="onConfirm(false, $event)">
        <i class="far fa-times-circle"></i>{{ confirmOptions.cancelText || 'No' }}
      </button>
      <button class="confirm-btn" (click)="onConfirm(true, $event)">
        <i class="far fa-check-circle"></i>{{ confirmOptions.confirmText || 'Yes' }}
      </button>
    </div>
  </div>
</ng-container>
